import React from "react";
import { TableRowRenderer } from "react-virtualized";
import { Link, LinkProps } from "react-router-dom";

export const rowRendererLink = (
  rowRenderer: TableRowRenderer,
  linkConfig: (params: any) => LinkProps | undefined
): TableRowRenderer => {
  return (params) => {
    const content = rowRenderer(params);
    const { onClick, to = "", ...props } = linkConfig(params) || {};

    return (
      <Link
        style={{ textDecoration: "none", color: "inherit" }}
        onClick={onClick}
        to={to}
        {...props}
      >
        {content}
      </Link>
    );
  };
};

export const cellRendererLink = (
  cellRenderer: (params: any) => any,
  linkConfig: (params: any) => LinkProps | undefined
) => {
  return (params: any) => {
    const content = cellRenderer ? cellRenderer(params) : params.value;
    const { to = "", onClick, ...props } = linkConfig(params) || {};

    return (
      <>
        <div style={{ zIndex: 1 }}>{content}</div>
        <Link
          className="cell-renderer-link"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
            textDecoration: "none",
            color: "inherit"
          }}
          to={to}
          onClick={onClick}
          {...props}
        />
      </>
    );
  };
};

export function isCellRendererLink(element: HTMLElement | null) {
  return element?.classList.contains("cell-renderer-link") ?? false;
}
